import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=889b9008&scoped=true&"
import script from "./Recommend.vue?vue&type=script&lang=ts&"
export * from "./Recommend.vue?vue&type=script&lang=ts&"
import style0 from "./Recommend.vue?vue&type=style&index=0&id=889b9008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889b9008",
  null
  
)

export default component.exports